import { TableCell } from "@mui/material";
import {
  IAdditional,
  IAdditionalHeaderProps,
} from "../../TableTemplate/tableTemplate";
import { IDeltaHedgeAccountTableReport } from "../../../Interfaces/deltaHedgeAccounts";
import DeleteIcon from "@mui/icons-material/Delete";
import { deleteDeltaHedgeAccount } from "../../../Requests/deltaHedgeAccounts";
// UI Frameworks
import { toast } from "react-toastify";
import EditIcon from "@mui/icons-material/Edit";
// Hooks
import { useAppDispatch } from "src/App/hooks";
// Actions
import {
  setHeltaHedgeAccountsAddEditModalFlag,
  setAddEditDeltaHedgeAccountsFormValues,
} from "src/Features/DeltaHedgeAccounts/deltaHedgeAccountsSlice";

const AdditionalHeader = ({}: IAdditionalHeaderProps) => {
  return (
    <>
      <TableCell />
      <TableCell />
    </>
  );
};

const AdditionalCol: React.FC<{
  row: IDeltaHedgeAccountTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  // hooks
  const dispatch = useAppDispatch();

  const deleteHandler = () => {
    deleteDeltaHedgeAccount(row.id).then((resp) => {
      if (!resp.data) toast.error(resp.msg);
      else {
        toast.success(resp.msg);
        onAction();
      }
    });
  };

  const editHandler = () => {
    dispatch(
      setAddEditDeltaHedgeAccountsFormValues({
        ...row,
        accountId: row.account_id,
        deltahedgeAccountId: row.deltahedegAccountId,
      })
    );
    dispatch(setHeltaHedgeAccountsAddEditModalFlag(true));
  };

  return (
    <>
      <TableCell>
        <div
          className="hover:bg-slate-300 transition-all rounded p-1"
          onClick={editHandler}
        >
          <EditIcon className="text-sky-700 cursor-pointer" />
        </div>
      </TableCell>
      <TableCell>
        <div onClick={deleteHandler}>
          <DeleteIcon
            fontSize="small"
            className="text-red-700 cursor-pointer"
          />
        </div>
      </TableCell>
    </>
  );
};

export const Additional: IAdditional<IDeltaHedgeAccountTableReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
